import * as devisConf from '@/configuration/devisConf';
import defineTitreIntervenant from './defineTitreIntervenant';

export default function addIntervenant(devisCommande, intervenant) {
  if (!devisCommande) {
    return;
  }
  devisCommande.intervenants = [];

  intervenant.payeur = true;
  intervenant.donneurOrdre = true;
  intervenant.annonceur = true;
  defineTitreIntervenant(intervenant);
  intervenant.repartition = 100;
  intervenant.typeRepartition = devisConf.POURCENTAGE;

  devisCommande.intervenants.push(intervenant);
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutIntervenant/addIntervenant.js